export default __webpack_public_path__ + "static/media/male.28ac01e3.png";